import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBWeq3fmX7cSht3ChiUZC9KGULCD9aTTI0",
  authDomain: "gifthub-34e0d.firebaseapp.com",
  projectId: "gifthub-34e0d",
  storageBucket: "gifthub-34e0d.appspot.com",
  messagingSenderId: "93972760268",
  appId: "1:93972760268:web:7fd9aaf811c1c73ca2a469",
  measurementId: "G-RBHFE6QZBP",
};

firebase.initializeApp(firebaseConfig);

export default firebase;
